module.exports = __webpack_public_path__ + "static/media/Roboto-Medium.50d01d3e.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Medium.woff2
// module id = 525
// module chunks = 0